function twoSum(arr, k) {
  //use set to store unique elements
  var hashMap = new Set();

  //Initialize to false
  var isFound = false;

  //Loop through each element
  for (var i = 0; i < arr.length; i++) {
    //Check if difference pair already exists in hashMap
    if (hashMap.has(k - arr[i])) {
      isFound = true;
      break;
    }

    hashMap.add(arr[i]);
  }
  return isFound;
}

export default twoSum;
